import { cn } from '@/lib/utils';

interface CenteredSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizeClasses = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

/**
 * Reusable centered loading spinner component
 * Used across the application for consistent loading states
 */
export function CenteredSpinner({ 
  className, 
  size = 'md',
  label = 'Chargement...'
}: CenteredSpinnerProps) {
  return (
    <div 
      className={cn(
        "min-h-screen flex items-center justify-center bg-background",
        className
      )}
      role="status"
      aria-label={label}
    >
      <div 
        className={cn(
          "animate-spin rounded-full border-b-2 border-primary",
          sizeClasses[size]
        )} 
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}

/**
 * Inline spinner for use within containers (not full-screen)
 */
export function InlineSpinner({
  className,
  size = 'md',
  label = 'Chargement...'
}: CenteredSpinnerProps) {
  return (
    <div 
      className={cn(
        "flex items-center justify-center py-8",
        className
      )}
      role="status"
      aria-label={label}
    >
      <div 
        className={cn(
          "animate-spin rounded-full border-b-2 border-primary",
          sizeClasses[size]
        )} 
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
